import { Image } from '@mantine/core';
import React from 'react';

import { dropdownArrowDownIcon, dropdownArrowUpIcon } from '@assets';

interface DropdownArrowProps {
  isOpen: boolean;
}

export const DropdownArrow: React.FC<DropdownArrowProps> = ({ isOpen }) => {
  return <Image src={isOpen ? dropdownArrowUpIcon : dropdownArrowDownIcon} />;
};
